export default {
      id: "ic-soc-facebook-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic-soc-facebook-usage",
      toString: function () {
        return this.url;
      }
    }